import { Remove } from "@mui/icons-material";
import { alpha, Stack, SxProps, Theme } from "@mui/material";
import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
} from "@mui/icons-material";

interface PriorityFindingsDeltaPercentageProps {
  deltaPercentage: number;
  deltaCount: number;
  color: "primary" | "secondary";
  testId?: string;
  small?: boolean;
  sx?: SxProps<Theme>;
}

export const PriorityFindingsDeltaPercentage = ({
  deltaPercentage,
  deltaCount,
  color,
  testId,
  small = false,
  sx,
}: PriorityFindingsDeltaPercentageProps) => (
  <Stack
    sx={[
      {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.2),
        color: `${color}.light`,
        borderRadius: 1,
        px: small ? 1 : 2.5,
        py: small ? 0.5 : 0.75,
        fontSize: small ? 14 : 24,
        fontWeight: 600,
        minWidth: small ? 50 : 80,
        height: small ? 24 : "auto",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    data-testid={testId}
  >
    <Stack
      sx={{ flexDirection: "row", flexGrow: "1", justifyContent: "center" }}
    >
      {deltaPercentage === 0 && deltaCount !== 0 ? "~" : ""}
      {Math.abs(deltaPercentage)}%
    </Stack>
    <Stack sx={{ flexDirection: "row" }}>
      {deltaCount < 0 && (
        <ArrowDownwardIcon sx={small ? { fontSize: 16 } : undefined} />
      )}
      {deltaCount > 0 && (
        <ArrowUpwardIcon sx={small ? { fontSize: 16 } : undefined} />
      )}
      {deltaCount === 0 && <Remove sx={small ? { fontSize: 16 } : undefined} />}
    </Stack>
  </Stack>
);
